import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ScrollTopButton__icon" }

import { withDefaults, ref, onMounted } from 'vue'

import { useScrollStickyPos } from '@/composables/useScrollStickyPos'

import { useBookshelfModeStore } from '@/store/bookshelfMode'

import AnimationPushToShadow from '@/components/AnimationPushToShadow/AnimationPushToShadow.vue'
import AppImage from '@/components/AppImage/AppImage.vue'

interface Props {
  keyboard?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollTopButton',
  props: {
    keyboard: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { keyboard: boolean }



// スクロールTOP
const onScrollTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
  document.body.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

// 本だなモード取得
const bookshelfModeStore = useBookshelfModeStore()
const isRankingShow = ref(false)
const isMyItemShow = ref(false)
bookshelfModeStore.$subscribe(async () => {
  isRankingShow.value = bookshelfModeStore.getRankingShow
  isMyItemShow.value = bookshelfModeStore.getMyItemShow
})

// スクロール位置調整
const { scrollY, getScrollY, isFootFix, options, intersectionCallback } =
  useScrollStickyPos()

onMounted(() => {
  // スクロールしてるか
  window.addEventListener('scroll', getScrollY)
  document.body.addEventListener('scroll', getScrollY)

  // キーボードがあるかないか
  const footer = document.querySelector('.l_footer') as HTMLElement
  const observer = new window.IntersectionObserver(
    intersectionCallback,
    options
  )
  if (footer) {
    observer.observe(footer)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_unref(scrollY) > 10)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["ScrollTopButton", {
        'is-keyboard': __props.keyboard,
        'is-ranking': isRankingShow.value,
        'is-myItem': isMyItemShow.value,
        'is-fix': _unref(isFootFix),
      }])
          }, [
            _createElementVNode("button", {
              class: "ScrollTopButton__button animationLink",
              onClick: onScrollTop
            }, [
              _createVNode(AnimationPushToShadow, {
                tag: "span",
                backgroundColor: "#eaeef4",
                shadowColor: "#93a8b5",
                rounded: "circle"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(AppImage, {
                      src: require('@/assets/image/icon/icon_arrow_top.svg'),
                      alt: "上へ戻る"
                    }, null, 8, ["src"])
                  ])
                ]),
                _: 1
              })
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})